import { IFileDesc } from '@app-types/websocket/file.types';
import { number } from 'prop-types';

export enum ChatType {
  UNKNOWN = 'UNKNOWN',
  CHAT = 'CHAT',
  CHANGE_REQUEST_CHAT = 'CHANGE_REQUEST_CHAT',
  AGREEMENT_CHAT = 'AGREEMENT_CHAT',
  PURCHASE_CHAT = 'PURCHASE_CHAT',
  TRANSFER_CHAT = 'TRANSFER_CHAT',
  EVENT_CHAT = 'EVENT_CHAT',
  SCHEDULE_CHAT = 'SCHEDULE_CHAT',
  SYSTEM_CHAT = 'SYSTEM_CHAT',
  PRIVATE_CHAT = 'PRIVATE_CHAT',
  TOPIC_CHAT = 'TOPIC_CHAT',
}

export enum ChatMsgStatus { // only used for messages in transit
  UNKNOWN = 'UNKNOWN',
  AWAIT_RESULT = 'AWAIT_RESULT',
  SENT = 'SENT',
  HALTED = 'HALTED',
}

export interface ILocallyStoredMsg {
  chatId: number;
  msg: string;
  uploadInternalIds?: number[];
  attachmentIds?: number[];
  uploadDraftSessionId?: number;
}

export interface ICreateChat {
  chatType: ChatType;
  participants: number[];
  title: string;
  msg: string;
  referenceObject?: number;
  icon?:string;
}

export interface IToxicCheck {
  chatId: number;
  msg: string;
}

export interface ICreateChatMessage {
  chatId: number;
  attachmentId?: number;
  msg: string;
  questionId?: number;
}

export interface ICreateChatMessageAction {
  id: number;
  send: boolean;
}

// The server answers with a chat message from the system that names the sender and links to the spot.
export interface IChatCheckIn {
  chatId: number;
  latitude: number;
  longitude: number;
}

export interface IInviteMember {
  account: number;
  email: string;
}

export interface IRequestChatMessages {
  chatId: number;
  startId: number;
  numMsgsBack: number;
  search?:string;
}

export interface IChatReceipt {
  chatId: number;
}

export interface IRequestMessageReadInfo {
  chatId: number;
  msgId: number;
}

export interface IMessageReadStatus {
  status: 'SENDER' | 'READ' | 'READ_TIME_UNKNOWN' | 'UNREAD' | 'NO_RECORD';
  readTime?: number;
  source?: 'RECEIPT' | 'IMPLIED_BY_SEND';
  impliedByMsgId?: number;
  readBefore?: number;
  formerParticipant?: boolean;
}

export interface IMessageReadInfo extends IRequestMessageReadInfo {
  senderId: number;
  sendingTime: number;
  asOf: number;
  participants: {[accountId:string]:IMessageReadStatus};
}

export interface IChatMessage {
	id: number;
	chatId: number;
	senderId: number;
	sendingTime : number;
  msg:string;
  fileDesc?:IFileDesc;
  chatType?:CHAT_TYPE;
  questionId?:number;
  callId?:number;
  toxic?:number;
  status?:ChatMsgStatus; // only used for messages in transit
  rewrite?:string; // only used for messages in transit
  strict?:boolean; // only used for messages in transit
  toxicVerdict?:number; // only used for messages in transit, see services/chat/toxicVerdict
}

export interface IChatReaction {
	id: number;
	chatId: number;
	senderId: number;
	sendingTime : number;
  msg:string;
}

export interface IChatUpdate {
  id: number;
  participants?: { [key:string]:IChatParticipant; };
	messages?:IChatMessage[];
  inTransitMessages?:IChatMessage[];
	icon?:string;
	title?:string;
	hidden?:number[];
}

export interface IChatParticipant {
  lastRead:number;
  removed?:boolean;
}

export interface IChatAlteration {
  id: number;
  title:string;
  icon?:string;
  participants?:number[];
}

export interface IChat {
  id: number;
  chatType: ChatType;
  referenceObject: number;
  title:string; 
  icon?:string;
  participants:{ [key:string]:IChatParticipant; }; // the key is always a number
  messages:IChatMessage[];
  messagesInTransit?:IChatMessage[];
  hidden?:number[];
}

export enum CHAT_TOPICS {
  IMAGE_LIBRARY = 1,
  SCHOOL_INFORMATION = 2,
  HEALTH = 3,
  IMPORTANT_PAPERS = 4,
  CONTACT = 5,
  FRIENDS = 6,
  CLOTHES = 7,
}

export enum CHAT_TYPE {
  UNKNOWN = "UNKNOWN", 
  CHAT = "CHAT", 
  CHANGE_REQUEST_CHAT = "CHANGE_REQUEST_CHAT", 
  EVENT_CHAT = "EVENT_CHAT", 
  SCHEDULE_CHAT = "SCHEDULE_CHAT",  
  SYSTEM_CHAT = "SYSTEM_CHAT", 
  PRIVATE_CHAT = "PRIVATE_CHAT", 
  TOPIC_CHAT = "TOPIC_CHAT", 
  AGREEMENT_CHAT = "AGREEMENT_CHAT", 
  PURCHASE_CHAT = "PURCHASE_CHAT", 
  TRANSFER_CHAT = "TRANSFER_CHAT", 
}



// WEBPACK FOOTER //
// ./src/app-types/websocket/chat.types.ts